import { RootState } from "../rootReducer";

export const isDemoOpen = (state: RootState) =>
  state.VisitorsReducer.isDemoOpen;
export const resetEmail = (state: RootState) =>
  state.VisitorsReducer.resetEmail;
